import styled from 'styled-components';

const SectionTitleStyle = styled.div`
  text-align: center;

  p {
    font-family: 'RobotoMono Regular', serif;
    font-size: 2rem;
  }

  h2 {
    font-family: 'Montserrat Bold', serif;
    font-size: 6rem;
    margin-top: 0.5rem;
    text-transform: uppercase;
  }

  @media only screen and (max-width: 768px) {
    text-align: center;
    p {
      font-size: 1.2rem;
    }

    h2 {
      font-size: 3.6rem;
    }
  }
`;

export const SectionTitle = ({subheading = 'Need Subheading', heading = 'need heading'}) => {
    return (
        <SectionTitleStyle className="section-title">
            <p>{subheading}</p>
            <h2>{heading}</h2>
        </SectionTitleStyle>
    )
}